import { ContactsTabs } from "@/pages/ContactsPage/Components/ContactsTabs";
import { ContactsPersonCard } from "../../../../ContactsPersonCard";
import { TagsField, AdditionalInfo } from "../../../../Fields";
import styles from "../../styles.module.scss";

export const View = () => {
  return (
    <div className={styles.root}>
      <div className={styles["person-card"]}>
        <ContactsPersonCard showEdit form />
        <div className={styles.tags}>
          <TagsField />
        </div>
        <AdditionalInfo />
      </div>
      <ContactsTabs />
    </div>
  );
};
